import { getResearchCard } from "./modelConfig";
import { FINAL_CONSENSUS } from "./debateRoundsData";

function sectionsToHtml(sections = []) {
  return sections
    .map((section) => {
      const bullets = section.bullets.map((b) => `<li>${b}</li>`).join("");
      return `<h3>${section.title}</h3><ul>${bullets}</ul>`;
    })
    .join("");
}

export function researchModelEditorPayload(modelKey) {
  const card = getResearchCard(modelKey);
  if (!card) return null;
  return {
    title: `${card.name}'s Response Analysis`,
    html: sectionsToHtml(card.sections),
  };
}

export function finalConsensusEditorPayload() {
  const bullets = FINAL_CONSENSUS.bullets.map((b) => `<li>${b}</li>`).join("");
  return {
    title: "Final Consensus Summary",
    html: `<ul class="nl-debate-consensus-bullets">${bullets}</ul>`,
  };
}
